module.exports = __webpack_public_path__ + "static/media/podcast_logo_2.eb3da283.png";